import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-negociation-devis',
  templateUrl: './negociation-devis.component.html',
  styleUrls: ['./negociation-devis.component.scss']
})
export class NegociationDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
